// import React from "react";


// const categories = [
//   "Cotton Saree",
//   "Pattu Saree",
//   "Fancy Saree",
//   "Trendy Sarees",
//   "Long Gowns",
//   "Salwar Kameez"
// ];

// const CategoryFilter = ({ filters, setFilters }) => {
//   const toggle = (value) => {
//     setFilters((prev) => ({
//       ...prev,
//       categories: prev.categories.includes(value)
//         ? prev.categories.filter((v) => v !== value)
//         : [...prev.categories, value]
//     }));
//   };

//   return (
//     <div>
//       <h4 className="font-medium mb-2">Categories</h4>
//       <div className="space-y-2">
//         {categories.map((cat) => (
//           <label key={cat} className="flex items-center gap-2 text-sm">
//             <input
//               type="checkbox"
//               checked={filters.categories.includes(cat)}
//               onChange={() => toggle(cat)}
//             />
//             {cat}
//           </label>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CategoryFilter;


import React from "react";

const CategoryFilter = ({ filters, setFilters, categoryCounts }) => {
  const toggleCategory = (slug) => {
    setFilters((prev) => ({
      ...prev,
      categories: prev.categories.includes(slug)
        ? prev.categories.filter((c) => c !== slug)
        : [...prev.categories, slug]
    }));
  };

  if (!categoryCounts || !Object.keys(categoryCounts).length) {
    return null;
  }

  return (
    <div>
      <h4 className="font-medium mb-3">Category</h4>

      <div className="space-y-2">
        {Object.entries(categoryCounts).map(([slug, data]) => (
          <label
            key={slug}
            className="flex items-center justify-between text-sm cursor-pointer"
          >
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={filters.categories.includes(slug)}
                onChange={() => toggleCategory(slug)}
              />
              <span>{data.label}</span>
            </div>

            <span className="text-gray-400 text-xs">
              ({data.count})
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;
